import { render, staticRenderFns } from "./CardMegaMenuLevelOneMobile.vue?vue&type=template&id=214e4445&scoped=true&"
import script from "./CardMegaMenuLevelOneMobile.vue?vue&type=script&lang=js&"
export * from "./CardMegaMenuLevelOneMobile.vue?vue&type=script&lang=js&"
import style0 from "./CardMegaMenuLevelOneMobile.vue?vue&type=style&index=0&id=214e4445&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214e4445",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsChevronLeft16px: require('/var/www/packages/theme/components/icons/chevron-left/ChevronLeft16px.vue').default})
